import { pxArrayToRem, pxToRem } from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';
import { hex2rgba } from '~/utils/colorHelper';

export const ColorSelectorPopup: StyleRule = ({ theme }) => ({
    position: 'absolute',
    minWidth: pxToRem(492),
    right: 0,
    top: pxToRem(55),
    maxHeight: pxToRem(680),
    padding: pxArrayToRem([24, 36]),
    overflow: 'hidden auto',
    zIndex: theme.siteVariables.zIndexes.menuItem,
    outline: `${pxToRem(2)} solid ${
        theme.siteVariables.colors.charcoal['250']
    }`,
    backgroundColor: theme.siteVariables.colors.white['100A'],
    boxShadow: `${pxArrayToRem([0, 14, 24, 2])} ${hex2rgba(
        theme.siteVariables.colors.primitive.black,
        0.08
    )}`,
    '&::-webkit-scrollbar': {
        width: pxToRem(6),
    },
    '&::-webkit-scrollbar-track': {
        backgroundColor: theme.siteVariables.colors.white[300],
    },
    '&::-webkit-scrollbar-thumb:vertical': {
        backgroundColor: theme.siteVariables.colors.charcoal[250],
    },
});

export const PopupTitle: StyleRule = ({ theme }) => ({
    fontSize: theme.siteVariables.fontSizes['label01'],
    paddingLeft: pxToRem(13),
    lineHeight: '110%',
    marginBottom: theme.siteVariables.spaces['space-24'],
    letterSpacing: theme.siteVariables.letterSpacingMedium,
});

export const ColorGrid: StyleRule = () => ({
    display: 'grid',
    gridTemplateColumns: `repeat(3, ${pxToRem(132)})`,
    columnGap: pxToRem(16),
});
